import React, { Fragment, useState } from 'react'
import { Container, Grid } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import slogan from '../../../assets/logos/logo_finger_print.png'
import Colaboration from '../../../assets/logos/colaboration.png'
import Integrity from '../../../assets/logos/integrity.png'
import Availability from '../../../assets/logos/availability.png'
import Signature from '../../../assets/logos/signature.png'
import Security from '../../../assets/logos/security.png'
import Business from '../../../assets/logos/business.png'
import { RadioButton } from "@progress/kendo-react-inputs";
import './plan-pricing.css'
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";


function PlanPricingView(props) {
  (props.fromPage === 'profile' || props.fromPage === 'receives') && window.scrollTo(0, 0)
  const { t } = useTranslation()
  const [selectItem, setSelectItem] = useState(false)
  const [selectObject, setSelectObject] = useState({})

  const myStorage = window.localStorage;

  // const selectItems = (data, element, event) => {
  //   props.onClickAvaliablePlans(data, element, event)
  //   // props.onSelectPlan(event, element)
  //   // myStorage.setItem('plan-selected', JSON.stringify(element.id))
  //   setSelectItem(element.id)
  //   setSelectObject(element)
  // }

  const itemSelect = props.topScroll === true ? parseInt(myStorage.getItem('plan-selected')) : selectItem
  return (
    <Container spacing={6} lg={12} md={12} sm={12} xs={12} className='plan-pricing' >
      <div className='container-plan2 '>
        <Grid lg={6} md={6} sm={12} xs={12} className='plan-pricing-container-panelbar'>
          <PanelBar expandMode={"single"}>
            <PanelBarItem title={t('planPricingView.businessPlanTitle')}>
              {props.avaliablePlans.length > 0 ? props.avaliablePlans.map((item, index) => {
                if (item.key === process.env.REACT_APP_PLAN_STANDAR_PLUS_KEY) {
                  return (
                    <Grid xs={12} lg={12} md={12} sm={12}>
                      <div onClick={(event) => { props.onClickAvaliablePlans(index, item, event) }} className='plan-pricing-container-avaliable-business-plan' >
                        <Grid xs={1} lg={1} md={1} sm={1} className='plan-pricing-align-center'>
                          <RadioButton className={"checkPlan"} />
                        </Grid>
                        <Grid xs={11} lg={11} md={11} sm={11} className='plan-pricing-general-information-avaliable-plan'>
                          <div>
                            <span>{t("planPricingView.businessPlan")}</span>&nbsp;
                          </div>
                          <span className='plan-pricing-package-general-information-subtitle'>{t("planPricingView.businessPlan.description")}</span>
                        </Grid>
                        {/* <Grid xs={4} lg={4} md={4} sm={4} className='plan-pricing-avaliable-price avaliable-price-business-plan'>
                          <span> {item.pricing} MXM</span>
                        </Grid> */}
                      </div>
                    </Grid>
                  )
                }
              }) : <Fragment></Fragment>}
            </PanelBarItem>
            <PanelBarItem title={t('planPricingView.planTitle')}>
              {/* {props.avaliablePlans.length > 0 ? props.avaliablePlans.map((item, index) => {
                if (item.planId === Number(process.env.REACT_APP_PLAN_PREPAID)) {
                  return (
                    <Grid xs={12} lg={12} md={12} sm={12}>
                      <div onClick={(event) => { props.onClickAvaliablePlans(index, item, event) }} className='plan-pricing-container-avaliable-plan'>

                        <Grid xs={1} lg={1} md={1} sm={1} className='plan-pricing-align-center'>
                          <RadioButton className={"checkPlan"} />
                        </Grid>
                        <Grid xs={7} lg={7} md={7} sm={7} className='plan-pricing-general-information-avaliable-plan' >
                          <div>
                            <span>{item.name}</span>&nbsp;
                          </div>
                          <span className='plan-pricing-package-general-information-subtitle'>Incluye {item.annualTransaction} créditos. Precio más IVA</span>
                        </Grid>
                        <Grid xs={5} lg={5} md={5} sm={5} className='plan-pricing-avaliable-price avaliable-price-plan'>
                          <span> {item.pricing} MXM</span>
                        </Grid>
                      </div>
                    </Grid>
                  )
                }
              }) : null} */}
            </PanelBarItem>
            <PanelBarItem title={t('planPricingView.packageTitle')}>
              {/* {props.avaliablePlans.length > 0 ? props.avaliablePlans.map((item, index) => {
                if (item.planId === Number(process.env.REACT_APP_PLAN_ESTANDAR) && item.key !== process.env.REACT_APP_PLAN_STANDAR_PLUS_KEY) {
                  return (
                    <Grid xs={12} lg={12} md={12} sm={12}>
                      <div onClick={(event) => { props.onClickAvaliablePackage(index, item, event) }} className='plan-pricing-container-avaliable-package' >
                        <Grid xs={1} lg={1} md={1} sm={1} className='plan-pricing-align-center'>
                          <RadioButton className={"checkPlan"} />
                        </Grid>
                        <Grid xs={7} lg={7} md={7} sm={7} className='plan-pricing-general-information-avaliable-plan'>
                          <div>
                            <span>{item.name}</span>&nbsp;
                          </div>
                          <span className='plan-pricing-package-general-information-subtitle'>Incluye {item.annualTransaction} créditos. Precio más IVA</span>
                        </Grid>
                        <Grid xs={5} lg={5} md={5} sm={5} className='plan-pricing-avaliable-price avaliable-price-package'>
                          <span> {item.pricing} MXM</span>
                        </Grid>
                      </div>
                    </Grid>
                  )
                }
              }) : <Fragment></Fragment>} */}
            </PanelBarItem>

          </PanelBar>
        </Grid>
        <Grid lg={6} md={6} sm={12} xs={12} className='plan-pricing-container-panelbar'>
          {props.assignedPlans[0] ?
            <Grid xs={12} lg={12} md={12} sm={12}>
              <div onClick={(event) => { props.onClickAssignedPlan(event) }} className={props.assignedPlans[0].key === process.env.REACT_APP_PLAN_STANDAR_PLUS_KEY ? 'plan-pricing-container-assigned-business-plan' : 'plan-pricing-container-assigned-plan'} >
                <Grid xs={1} lg={1} md={1} sm={1} className='plan-pricing-align-center'>
                  <RadioButton className={"checkPlanDark"} />
                </Grid>
                {props.assignedPlans[0].key === process.env.REACT_APP_PLAN_STANDAR_PLUS_KEY ?
                  <Grid xs={11} lg={11} md={11} sm={11} className='plan-pricing-general-information-assigned-plan'>
                    <div>
                      <span>{t("planPricingView.businessPlan")}</span>&nbsp;
                    </div>
                    <span className='plan-pricing-package-general-information-subtitle'>{t("planPricingView.businessPlan.description")}</span>
                  </Grid>
                  :
                  <Grid xs={7} lg={7} md={7} sm={7} className='plan-pricing-general-information-assigned-plan'>
                    <div>
                      <span>{props.assignedPlans[0].name}</span>&nbsp;
                    </div>
                    <span className='plan-pricing-package-general-information-subtitle'> Incluye {props.assignedPlans[0].annualTransaction} créditos. Precio más IVA</span>
                  </Grid>
                }
                {props.assignedPlans[0].key === process.env.REACT_APP_PLAN_STANDAR_PLUS_KEY ? null :
                  <Grid xs={5} lg={5} md={5} sm={5} className='assigned-price avaliable-price'>
                    <span> {props.assignedPlans[0].pricing} MXM</span>&nbsp;
                  </Grid>
                }
              </div>
            </Grid>
            :
            null
          }
          {props.assignedPackage[0] ?
            <Grid xs={12} lg={12} md={12} sm={12}>
              <div onClick={(event) => { props.onClickAssignedPackage(event) }} className='plan-pricing-container-assigned-package' >
                <Grid xs={1} lg={1} md={1} sm={1} className='plan-pricing-align-center' >
                  <RadioButton className={"checkPlanDark"} />
                </Grid>
                <Grid xs={7} lg={7} md={7} sm={7} className='plan-pricing-general-information-assigned-plan'>
                  <div>
                    <span>{props.assignedPackage[0].name}</span>&nbsp;
                  </div>
                  <span className='plan-pricing-package-general-information-subtitle'>Incluye {props.assignedPackage[0].annualTransaction} créditos. Precio más IVA</span>
                </Grid>
                <Grid xs={5} lg={5} md={5} sm={5} className='assigned-price avaliable-price'>
                  <span> {props.assignedPackage[0].pricing} MXM</span>
                </Grid>
              </div>
            </Grid>
            :
            null
          }
          {(props.assignedPackage[0]) ?
            <Grid className='plan-pricing-container-car' xs={12} lg={12} md={12} sm={12} >
              <Grid xs={5} lg={5} md={5} sm={5} className='plan-pricing-total-price-grid'>
                <div className='plan-pricing-total-price'>
                  <span>TOTAL DE COMPRA</span>&nbsp;
                </div>
              </Grid>
              <Grid className='container-avaliable-assigned' xs={7} lg={7} md={7} sm={7}>
                <Grid className='container-package' xs={12} lg={12} md={12} sm={12}>
                  <Grid xs={4} lg={4} md={4} sm={4} className='plan-pricing-car'>
                    <span className='plan-pricing-package'>Subtotal </span>
                  </Grid>
                  <Grid xs={8} lg={8} md={8} sm={8} className='plan-pricing-price'>
                    <span> {props.subtotal} MXM</span>&nbsp;
                  </Grid>
                </Grid>
                <Grid className='container-package' xs={12} lg={12} md={12} sm={12}>
                  <Grid xs={4} lg={4} md={4} sm={4} className='plan-pricing-car'>
                    <span className='plan-pricing-package'>IVA </span>
                  </Grid>
                  <Grid xs={8} lg={8} md={8} sm={8} className='plan-pricing-price'>
                    <span> {props.iva} MXM</span>&nbsp;
                  </Grid>
                </Grid>
                <Grid className='container-package' xs={12} lg={12} md={12} sm={12}>
                  <Grid xs={4} lg={4} md={4} sm={4} className='plan-pricing-car'>
                    <span className='plan-pricing-package'>Total </span>
                  </Grid>
                  <Grid xs={8} lg={8} md={8} sm={8} className='plan-pricing-price-total'>
                    <span> {props.total} MXM</span>&nbsp;
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            : (props.assignedPlans[0]) ? (props.assignedPlans[0].id) === 8 ? null :
              <Grid className='plan-pricing-container-car' xs={12} lg={12} md={12} sm={12} >
                <Grid xs={5} lg={5} md={5} sm={5} className='plan-pricing-total-price-grid'>
                  <div className='plan-pricing-total-price'>
                    <span>TOTAL DE COMPRA</span>&nbsp;
                  </div>
                </Grid>
                <Grid className='container-avaliable-assigned' xs={7} lg={7} md={7} sm={7}>
                  <Grid className='container-package' xs={12} lg={12} md={12} sm={12}>
                    <Grid xs={4} lg={4} md={4} sm={4} className='plan-pricing-car'>
                      <span className='plan-pricing-package'>Subtotal </span>
                    </Grid>
                    <Grid xs={8} lg={8} md={8} sm={8} className='plan-pricing-price'>
                      <span> {props.subtotal} MXM</span>&nbsp;
                    </Grid>
                  </Grid>
                  <Grid className='container-package' xs={12} lg={12} md={12} sm={12}>
                    <Grid xs={4} lg={4} md={4} sm={4} className='plan-pricing-car'>
                      <span className='plan-pricing-package'>IVA </span>
                    </Grid>
                    <Grid xs={8} lg={8} md={8} sm={8} className='plan-pricing-price'>
                      <span> {props.iva} MXM</span>&nbsp;
                    </Grid>
                  </Grid>
                  <Grid className='container-package' xs={12} lg={12} md={12} sm={12}>
                    <Grid xs={4} lg={4} md={4} sm={4} className='plan-pricing-car'>
                      <span className='plan-pricing-package'>Total </span>
                    </Grid>
                    <Grid xs={8} lg={8} md={8} sm={8} className='plan-pricing-price-total'>
                      <span> {props.total} MXM</span>&nbsp;
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              :
              null
          }
        </Grid>
      </div>
      {/* <Grid lg={6} md={6} sm={12} xs={12} className='container-plans-price'>


      </Grid> */}
      {/* <div className='container-title-plans'><span className='title-plans'>{t('planPricingView.planType')}</span></div>
      <div className='container-plan2'>
        <Grid lg={6} md={6} sm={12} xs={12} className='container-plans-price'>

          {props.plan.length > 0 ? props.plan[0].planLevels.map((item, index) => {

            const selected = (item.id === itemSelect) ? 'items-plan selected-plan' : 'items-plan'
            const selectedHD = (item.id === itemSelect) ? 'items-plan-hardDark selected-plan' : 'items-plan-hardDark'
            const selectedCheck = (item.id === itemSelect) ? 'checkPlanSelect' : 'checkPlan'
            const selectedCheckHD = (item.id === itemSelect) ? 'checkPlanSelectHD' : 'checkPlan'

            const selectedElements = (item.id === itemSelect) ? 'item-title-plan selected-elements' : 'item-title-plan'
            const selectedElementsNum = (item.id === itemSelect) ? 'item-num-plan selected-price' : 'item-num-plan'
            const selectedElementsMoth = (item.id === itemSelect) ? 'item-desc-plan selected-elements' : 'item-desc-plan'

            const elementColor = (item.class === 'light') ? 'items-plan-light' : 'items-plan-dark'
            const elementHardDark = (item.class === 'hard-dark') ? 'items-plan-hardDark' : ''
            const elementDarkPrice = (item.class === 'dark') ? 'item-num-plan-dark' : ''
            const checkLightDark = (item.class === 'light') ? 'checkPlan' : 'checkPlanDark'
            const checkHardDark = (item.class === 'hard-dark') ? 'checkPlanHardDark' : ''
            const selectedElementsHd = (item.order === 7) ? 'item-title-plan-hd' : ' '
            const selectedElementsHard = (item.order === 7) ? 'item-desc-plan-hd' : ' '

            if (item.order === 1) {
              return null
            } else if (item.order === 7) {
              return (
                <Grid lg={12} md={12} sm={12} xs={12} className='space-plan'>
                  <div onClick={(event) => { selectItems(index, item, event) }} className={item.id === itemSelect ? selectedHD : elementHardDark}>
                    <RadioButton className={item.id === itemSelect ? selectedCheckHD : checkHardDark} />
                    <span className={selectedElementsHd}>{t('planPricingView.businessPlan')}</span>
                    <span className={selectedElementsHard}>{t('planPricingView.personalizedCredits')}</span>
                  </div>
                </Grid>
              )
            } else if (item.order === 8) {
              return null
            } {
              return (
                <Grid lg={12} md={12} sm={12} xs={12} className='space-plan'>
                  <div key={index} onClick={(event) => { selectItems(index, item, event) }} className={item.id === itemSelect ? selected : elementColor}>
                    <RadioButton className={item.id === itemSelect ? selectedCheck : checkLightDark} />
                    <span className={selectedElements}>
                      PLAN {props.plan[0].name + ' ' + item.monthlyTransaction}
                    </span>
                    <span className={item.class === 'dark' ? elementDarkPrice : selectedElementsNum}>
                      {item.pricing} MXN
                    </span>
                    <span className={selectedElementsMoth}>
                      {t('planPricingView.add')} {item.monthlyTransaction} {t('planPricingView.credits')}
                    </span>
                  </div>
                </Grid>
              )
            }

          }) : <div>{t('planPricingView.noData')}</div>}
          <div className='items-plan-notes'>
            <span className='space-notes'>{t('planPricingView.pricesAnnual')}</span>
            <span className='space-notes'>{t('planPricingView.validation')}</span>
            <span className='space-notes'>{t('planPricingView.mexicanPrice')}</span>
          </div>
        </Grid>

        <Grid lg={6} md={6} sm={12} xs={12} className='benefits'>
          <div className='content-desci'>
            <span className='title-items-h1'>{t('planPricingView.benefits')}</span>
            <div className='txt-align'>
              <p className='benefits-text'><img src={Colaboration} width='22' height='22' className='benefits-img' />{t('planPricingView.benefitsColaboration')}</p>
              <p className='benefits-text'><img src={Integrity} width='22' height='22' className='benefits-img' />{t('planPricingView.benefitsNOM')}</p>
              <p className='benefits-text'><img src={Availability} width='22' height='22' className='benefits-img' />{t('planPricingView.benefitsAvailability')}</p>
              <p className='benefits-text'><img src={Signature} width='22' height='22' className='benefits-img' />{t('planPricingView.benefitsSignatures')}</p>
              <p className='benefits-text'><img src={Security} width='22' height='22' className='benefits-img' />{t('planPricingView.benefitsSecurity')}</p>
              <p className='benefits-text-b'><img src={Business} width='22' height='22' className='benefits-img' />{t('planPricingView.benefitsBusiness')}</p>
            </div>
            {/* {props.plan.length > 0 ? props.plan[0].planFeatures.map((item, index) => {
              if (item.feature.name === 'Genera el sello de Tiempo Digital') return (<React.Fragment />)
              if (item.feature.name === 'Configura recordatorios para la firma de documento') return (<React.Fragment />)
              return (
                <div key={index}>
                  <p className='text-desci'><img alt='Logo de hibou.legal' height='10' src={slogan} />{item.feature.name}</p>
                </div>
              )
            }) : <div>{t('planPricingView.noData')}</div>} *
          </div>
        </Grid>
      </div>

      <div></div> */}

    </Container >
  )
}

export { PlanPricingView as default }